// extracted by mini-css-extract-plugin
export default {"nodeMainbodyContentTooltip":"nodeMainbodyContentTooltip___u4Sal"};